import React from 'react';
import { useSEO } from '../hooks/useSEO';
import ProductHero from '../components/ProductHero';
import Workflow from '../components/Workflow';

const V2FirestoppingDashboard = () => {
  useSEO({
    title: 'Firestopping Business Dashboard | Run the business',
    description: 'A complete operating environment for growing firestopping businesses — leads, quotations, projects, SafeTrace, remediation, QA, evidence, handover and invoicing.',
    path: '/firestopping/business-dashboard',
  });

  return (
    <div data-testid="v2-firestopping-dashboard">
      <ProductHero
        eyebrow="Firestopping Business Dashboard"
        title="Run the business. Control the work. Prove the installation."
        subtitle="A complete operating environment for growing firestopping businesses."
        body={(
          <>
            <p>Designed for small and medium-sized firestopping businesses that need better operational visibility without unnecessary enterprise complexity.</p>
            <p>Manage the journey from opportunity and quotation through project delivery, survey, remediation, QA, evidence, handover and commercial completion.</p>
            <p className="text-blue-700 font-medium">SafeTrace included.</p>
          </>
        )}
        primary={{ label: 'Explore the Business Dashboard', to: '/contact' }}
        testid="dashboard-hero"
      />

      <section className="py-16 md:py-20 bg-slate-50 border-y border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">Business journey</p>
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-slate-900 mb-10">From lead to invoice — connected.</h2>
          <Workflow testid="dashboard-workflow" steps={['Lead','Estimate','Quote','Order','Project','SafeTrace','Install / Remediate','QA','Evidence','Handover','Invoice']} />
        </div>
      </section>
    </div>
  );
};

export default V2FirestoppingDashboard;
